import { render, staticRenderFns } from "./presell.vue?vue&type=template&id=4b2fa2b8&scoped=true&"
import script from "./presell.vue?vue&type=script&lang=js&"
export * from "./presell.vue?vue&type=script&lang=js&"
import style0 from "./presell.vue?vue&type=style&index=0&id=4b2fa2b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2fa2b8",
  null
  
)

export default component.exports